import loadingPageSkel from '/resource/spine/tutorial/spine_tutorial.skel?url'
import loadingPageAtlas from '/resource/spine/tutorial/spine_tutorial.atlas?url'

import godziSkel from '/resource/spine/godzidrop/spine_godzidrop.skel?url'
import godziAtlas from '/resource/spine/godzidrop/spine_godzidrop.atlas?url'
import godziBetterLuckSkel from '/resource/spine/godzidrop/spine_godzidrop_betterLuck.skel?url'
import godziBetterLuckAtlas from '/resource/spine/godzidrop/spine_godzidrop_betterLuck.atlas?url'
import godziBgSkel from '/resource/spine/godzidrop/spine_godzi_bg.skel?url'
import godziBgAtlas from '/resource/spine/godzidrop/spine_godzi_bg.atlas?url'
import godziFreeSpinSkel from '/resource/spine/godzidrop/freeSpinAnime.skel?url'
import godziFreeSpinAtlas from '/resource/spine/godzidrop/freeSpinAnime.atlas?url'

export const getloadingPageSpineData = () => {
  const loadingPageSpineData = [
    { alias: 'loadingPageSkel', src: loadingPageSkel },
    { alias: 'loadingPageAtlas', src: loadingPageAtlas },
  ]

  return loadingPageSpineData
}

export const getGodziSpineData = () => {
  const godziSpineData = [
    { alias: 'godziSkel', src: godziSkel },
    { alias: 'godziAtlas', src: godziAtlas },
    { alias: 'godziBetterLuckSkel', src: godziBetterLuckSkel },
    { alias: 'godziBetterLuckAtlas', src: godziBetterLuckAtlas },
    { alias: 'godziBgSkel', src: godziBgSkel },
    { alias: 'godziBgAtlas', src: godziBgAtlas },
    { alias: 'godziFreeSpinSkel', src: godziFreeSpinSkel },
    { alias: 'godziFreeSpinAtlas', src: godziFreeSpinAtlas },
  ]

  return godziSpineData
}
